<template>
  <v-container>
    <NoncurrentAssets />
  </v-container>
</template>
<script>
// import { mapGetters, mapActions, mapMutations } from 'vuex'
// import { db, fb } from '@/api/firebase.js'
import NoncurrentAssets from '@/components/NoncurrentAssets.vue'
// import AccountReceivable from '@/components/AccountReceivable.vue'

export default {
  name: 'FixedAssets',
  components: { NoncurrentAssets },
  data: () => ({
  }),

  computed: {
    // ...mapGetters()
  },

  watch: {
  },

  /* created () {
  }, */

  methods: {
    // ...mapMutations(),
    // ...mapActions()
  }
}
</script>
<style type="text/css">
</style>
